module.exports = __webpack_public_path__ + "img/mlc - HPSVson.5e3c7f06.png";